import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle } from 'lucide-react';
export function OpeningHook() {
  return <section className="w-full bg-dark-panel py-20 border-b border-dark-lighter" data-id="element-142">
      <div className="max-w-3xl mx-auto px-6" data-id="element-143">
        <FadeIn data-id="element-144">
          <div className="flex items-center justify-center mb-8" data-id="element-145">
            <AlertTriangle className="text-cyan-accent w-10 h-10" data-id="element-146" />
          </div>
          <blockquote className="text-2xl md:text-3xl font-sans italic font-light text-gray-200 leading-relaxed text-center mb-10" data-id="element-147">
            "You’re in the middle of a high-stakes Zoom call when it happens. A
            white-hot bolt of lightning shoots from your lower back, down your
            hip, and into your heel."
          </blockquote>
          <div className="space-y-6 text-lg text-gray-400 font-sans leading-relaxed" data-id="element-148">
            <p data-id="element-149">
              You can’t stand up, you can’t sit back down, and you have to spend
              the next ten minutes pretending you aren’t in agony while the
              camera is on.
            </p>
            <p data-id="element-150">
              If you are a professional between 40 and 50, you aren't "getting
              old." You are simply being crushed by the 2,000 hours a year you
              spend in a seated position.
            </p>
            <div className="bg-dark p-6 border-l-4 border-cyan-accent mt-8" data-id="element-151">
              <p className="text-xl text-white font-semibold" data-id="element-152">
                Your body is biologically{' '}
                <span className="text-cyan-accent" data-id="element-153">"welding" itself shut.</span>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}